import React, { useEffect } from 'react'

import { Modal } from 'antd'
import { useDeleteRequestMutation } from '../../services/service/services.service' 
import { toast } from 'react-toastify'

export const ConfirmDeleteRequest = ({ visible, title, onCancel, okText, user }) => {

    
    const [deleteRequest, { data, isLoading, isSuccess, isError, error }] = useDeleteRequestMutation()
    const id=user?.id
   
    const handleOk = () => {
        deleteRequest(id)
    }

    useEffect (() => {
        if(isSuccess  || data?.code === 200){
            toast.success("request Deleted Successfully!", {
                toastId: "success"
            })
            setTimeout(() => {
            }, 3000);
        }
    })

    return (
        <Modal
            visible={visible}
            title={title}
            onOk={handleOk}
            onCancel={onCancel}
            okText={okText}
            className='user_modal_style'
            confirmLoading={isLoading}
        >

            {
                isError &&
                <div className='flex mt-3'>
                    <p className='text-red-500 text-md font-bold mx-3'>
                        {error?.name || error?.status}
                    </p>
                    <p className='text-red-500 text-md font-bold'>
                        {error?.message || error?.data.message}
                    </p>
                </div>
            }

            <p>
                Are you sure, you want to delete {user?.name}
            </p>
            <p>This will be deleted so soon</p>
        </Modal>
    )
}
